import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { reactular } from '@vendhq/reactular'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'

interface Props {
  close: (applyPartialAuth: Promise<boolean>) => void
  approvedAmount: number
}

export const PartialAuthModal: FC<Props> = ({ close, approvedAmount }) => {
  const t = useT()
  const vdCurrencyFilter = useVdCurrencyFilter()

  /**
   * Close the partial auth modal and apply payment
   *
   * @method makePartialAuth
   */
  const makePartialAuth = () => {
    close(Promise.resolve(true))
  }

  /**
   * Close the partial auth modal, refund the partial auth and apply refund
   *
   * @method reversePartialAuth
   */
  const reversePartialAuth = () => {
    close(Promise.resolve(false))
  }

  return (
    <Modal size="small">
      <ModalHeader>
        {t('Only {amount} of this payment has been approved.', {
          amount: vdCurrencyFilter(approvedAmount),
          _context: 'Payment modal header',
        })}
      </ModalHeader>
      <ModalContent>
        <p className="vd-p">
          {t(
            'Continue to take payment for the remaining balance, or refund this amount to take payment another way or discard the sale.',
            {
              _context:
                'The partial payment auth modal description suggests options for handling a remaining balance',
            }
          )}
        </p>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button
            data-track="refund-partial-payment"
            variant="supplementary"
            onClick={reversePartialAuth}
          >
            {t('Refund Partial Payment', {
              _context: 'Button label to refund partial payment',
            })}
          </Button>
          <Button
            data-track="continue-partial-auth"
            variant="go"
            onClick={makePartialAuth}
            autoFocus
          >
            {t('Continue', {
              _context: 'Button label to continue',
            })}
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}

export const PartialAuthModalComponent = reactular(
  PartialAuthModal,
  ['close', 'approvedAmount'],
  'reactWrapper'
)
